var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "title-container"
  }, [_c('capusta-title', {
    attrs: {
      "title": _vm.merchantName,
      "icon-outside": ""
    }
  })], 1), _c('div', {
    staticClass: "content-container"
  }, [_vm.localization ? _c('div', {
    staticClass: "option-container",
    on: {
      "click": _vm.handleShownLocalizationList
    }
  }, [_c('option-panel', {
    attrs: {
      "option": _vm.localization,
      "noactive": ""
    }
  }, [_c('div', {
    class: _vm.$style.iconLocalization,
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('country-flag', {
    attrs: {
      "language-code": _vm.localization.code
    }
  })], 1), _c('cs-button', {
    attrs: {
      "type": "secondary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.change')) + " ")])], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "option-container"
  }, [_vm.isNeedIdentification || _vm.isApproved ? _c('capusta-panel', {
    attrs: {
      "icon": "icon-identity-white",
      "description": _vm.$t('common.identification')
    },
    on: {
      "click": _vm.goToIdentity
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "option-container"
  }, [_c('capusta-panel', {
    attrs: {
      "icon": "icon-eagle-white",
      "description": _vm.selfEmployedTitle
    },
    on: {
      "click": _vm.goToSelfEmployed
    }
  })], 1), _c('div', {
    staticClass: "option-container"
  }, [_c('capusta-panel', {
    attrs: {
      "icon": "icon-key-white",
      "description": _vm.$t('account.secure')
    },
    on: {
      "click": _vm.goToTwoFactor
    }
  })], 1), _c('div', {
    staticClass: "option-container"
  }, [_c('capusta-panel', {
    attrs: {
      "icon": "icon-time-white",
      "description": _vm.$t('common.timezone')
    },
    on: {
      "click": _vm.goToTimeZone
    }
  })], 1)]), _c('languages-list-modal', {
    attrs: {
      "languages": _vm.formattedLanguages
    },
    on: {
      "change-localization": _vm.handleChangeLocalization
    },
    model: {
      value: _vm.isShownLocalizationList,
      callback: function callback($$v) {
        _vm.isShownLocalizationList = $$v;
      },
      expression: "isShownLocalizationList"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }